(function () {
  var state = window.ycChatGPTAds || {};
  var sentKeys = {};
  var lastCartAddSignature = '';
  var lastCartAddAt = 0;
  var registrationFlagKey = 'ycChatGPTAdsCreateCustomerSubmitted';

  function normalizeCurrency(currency) {
    return String(currency || state.currency || 'USD').toUpperCase();
  }

  function amountFromCents(cents) {
    var value = Number(cents || 0);
    if (!Number.isFinite(value)) return 0;
    return Math.round(value);
  }

  function contentItemFromProduct(product, amount, currency, quantity) {
    if (!product) return null;

    return {
      id: String(product.variantId || product.id || ''),
      name: String(product.title || ''),
      content_type: 'product',
      quantity: Math.max(1, Math.round(Number(quantity || 1))),
      amount: amount,
      currency: normalizeCurrency(currency)
    };
  }

  function pageUrl() {
    return window.location.href.split('#')[0];
  }

  function basePayload(data) {
    var payload = {
      type: 'customer_action'
    };

    Object.keys(data || {}).forEach(function (key) {
      if (data[key] !== undefined && data[key] !== null) {
        payload[key] = data[key];
      }
    });

    if (payload.currency) {
      payload.currency = normalizeCurrency(payload.currency);
    }

    return payload;
  }

  function measure(eventName, data, dedupeKey, options) {
    if (!eventName) return false;
    if (dedupeKey && sentKeys[dedupeKey]) return true;
    if (typeof window.oaiq !== 'function') return false;

    if (dedupeKey) sentKeys[dedupeKey] = true;

    try {
      if (options) {
        window.oaiq('measure', eventName, basePayload(data), options);
      } else {
        window.oaiq('measure', eventName, basePayload(data));
      }
      return true;
    } catch (error) {
      return false;
    }
  }

  function measureWhenReady(eventName, data, dedupeKey, options) {
    if (measure(eventName, data, dedupeKey, options)) return;

    document.addEventListener(
      'yc:chatgpt-ads:ready',
      function () {
        measure(eventName, data, dedupeKey, options);
      },
      { once: true }
    );
  }

  function sendInitialEvents() {
    measureWhenReady(
      'page_viewed',
      {
        type: 'contents'
      },
      'page_viewed:' + pageUrl()
    );

    if (state.product) {
      var productAmount = amountFromCents(state.product.priceCents);
      var productCurrency = state.product.currency || state.currency;

      measureWhenReady(
        'contents_viewed',
        {
          type: 'contents',
          amount: productAmount,
          currency: productCurrency,
          contents: [contentItemFromProduct(state.product, productAmount, productCurrency, 1)].filter(Boolean)
        },
        'contents_viewed:' + state.product.variantId + ':' + pageUrl()
      );
    }

    if (window.location.pathname.replace(/\/+$/, '') === '/cart') {
      measureWhenReady(
        'custom',
        {
          type: 'custom'
        },
        'cart_viewed:' + pageUrl(),
        { custom_event_name: 'cart_viewed' }
      );
    }

    if (state.pageType === 'search') {
      measureWhenReady(
        'custom',
        {
          type: 'custom'
        },
        'search_submitted:' + pageUrl(),
        { custom_event_name: 'search_submitted' }
      );
    }
  }

  function cartAddSignature(data) {
    return [
      data.variant_id || data.variantId || '',
      data.product_id || data.productId || '',
      data.quantity || data.itemCount || 1
    ].join(':');
  }

  function sendCartAdd(data) {
    var signature = cartAddSignature(data || {});
    var now = Date.now();
    if (signature === lastCartAddSignature && now - lastCartAddAt < 1500) return;

    lastCartAddSignature = signature;
    lastCartAddAt = now;

    measureWhenReady('items_added', {
      type: 'contents',
      amount: amountFromCents(data.amount || 0),
      currency: data.currency || state.currency,
      contents: [
        {
          id: String(data.variant_id || data.variantId || data.product_id || data.productId || ''),
          name: String(data.product_title || data.productTitle || ''),
          content_type: 'product',
          quantity: Math.max(1, Math.round(Number(data.quantity || data.itemCount || 1))),
          amount: amountFromCents(data.amount || 0),
          currency: normalizeCurrency(data.currency || state.currency)
        }
      ]
    });
  }

  function bindThemeCartEvents() {
    document.addEventListener(
      'cart:update',
      function (event) {
        var detail = event.detail || {};
        var data = detail.data || {};
        if (data.didError) return;

        sendCartAdd({
          productId: data.productId,
          variantId: detail.sourceId,
          itemCount: data.itemCount || 1,
          currency: state.currency
        });
      },
      true
    );
  }

  function requestPath(input) {
    try {
      var raw = typeof input === 'string' ? input : input && input.url;
      return new URL(raw || '', window.location.origin).pathname;
    } catch (error) {
      return '';
    }
  }

  function requestMethod(input, init) {
    return String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
  }

  function bindFetchCartEvents() {
    if (typeof window.fetch !== 'function' || window.fetch.ycChatGPTAdsWrapped) return;

    var originalFetch = window.fetch;
    var wrappedFetch = function (input, init) {
      var path = requestPath(input);
      var method = requestMethod(input, init);
      var isCartAdd = method === 'POST' && /\/cart\/add(\.js)?$/.test(path);

      return originalFetch.apply(this, arguments).then(function (response) {
        if (isCartAdd && response && response.ok && typeof response.clone === 'function') {
          response
            .clone()
            .json()
            .then(function (item) {
              sendCartAdd({
                product_id: item.product_id,
                variant_id: item.variant_id || item.id,
                quantity: item.quantity || 1,
                amount: amountFromCents(item.final_line_price || item.line_price || item.price),
                currency: state.currency
              });
            })
            .catch(function () {});
        }

        return response;
      });
    };

    wrappedFetch.ycChatGPTAdsWrapped = true;
    window.fetch = wrappedFetch;
  }

  function bindRegistrationIntent() {
    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!(form instanceof HTMLFormElement)) return;

        var formType = form.querySelector('input[name="form_type"]');
        var isCreateCustomerForm = formType && formType.value === 'create_customer';
        if (!isCreateCustomerForm) return;

        try {
          window.sessionStorage.setItem(registrationFlagKey, '1');
        } catch (error) {}
      },
      true
    );
  }

  function sendRegistrationCompleteIfNeeded() {
    if (!state.customerLoggedIn) return;

    try {
      if (window.sessionStorage.getItem(registrationFlagKey) !== '1') return;
      window.sessionStorage.removeItem(registrationFlagKey);
    } catch (error) {
      return;
    }

    measureWhenReady(
      'registration_completed',
      {
        type: 'customer_action'
      },
      'registration_completed'
    );
  }

  function start() {
    sendInitialEvents();
    sendRegistrationCompleteIfNeeded();
    bindRegistrationIntent();
    bindThemeCartEvents();
    bindFetchCartEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
